var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-audio"},[_c('audio',{ref:"audioRef",attrs:{"autoPlay":"","muted":_vm.muted}})])
}
var staticRenderFns = []

export { render, staticRenderFns }